import styled from "styled-components"


const TradeBox = styled.div`
  background-color: ${props => props.theme.mainBg};
  //margin: 1px;
  border: 1px solid ${props => props.theme.color}15;
  position: relative;
  padding: ${props => props.padding};
  direction: ${props => props.theme.english ? 'ltr' : 'rtl'};
`

const ChangeBox = styled(TradeBox)`
  //width: calc(74% - 2px);
  //width: 100%;
  //height: 80px;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 80px;
  min-width: 700px;
  
  @media screen and (max-width: 1050px){
    width: calc(100% - 2px);
  }
`

const PercentBox = styled(TradeBox)`
  //width: calc(26% - 2px);
  width: 100%;
  height: 100%;
  min-height: 80px;
  min-width: 300px;
  overflow: auto;
`

const OrdersBox = styled(TradeBox)`
  width: 100%;
  height: 100%;
  min-width: 260px;
  padding: 15px;
  
  @media screen and (max-width: 1050px){
    min-width: unset;
  };
`

const ChartBox = styled(TradeBox)`
  width: 100%;
  height: 100%;
  min-height: 320px;
  filter: invert(1%) sepia(20%) saturate(98%) hue-rotate(1deg) brightness(82%) contrast(97%);
`

const PairsBox = styled(TradeBox)`
  width: 100%;
  height: 100%;
  padding: 10px 15px;
  min-height: 340px;
`

const LastTradesBox = styled(TradeBox)`
    width: 100%;
    height: 100%;
    position: relative;
    padding: 0 15px;

    @media screen and (max-width: 1050px){
      min-height: 380px;
    }
`

const TradingBox = styled(TradeBox)`
  width: 100%;
  min-height: 480px;
  height: 100%;
  
`

const HistoryBox = styled(TradeBox)`
  width: 100%;
  min-height: 520px;
  height: 100%;
  
  @media screen and (max-width: 1050px){
    //min-height: 420px;
    height: 100%;
  }
`



export {
  TradeBox,
  OrdersBox,
  PairsBox,
  ChangeBox,
  ChartBox,
  PercentBox,
  LastTradesBox,
  TradingBox,
  HistoryBox
}
